import { MutationTree } from "vuex";
import { RootState } from "@/store/types";
import { Location } from "vue-router";

export const mutations: MutationTree<RootState> = {
  setRedirectPath: (state, payload: Location | null) => {
    state.redirectPath = payload;
  },
  setPageNotFound: (state, payload) => (state.pageNotFound = payload),
};
